<template>
	<div
		:aria-selected="selected"
		:class="[{selected: selected}]"
		role="menuitemradio"
		class="menu-icon-option-item"
		tabindex="0"
		@click="onSelect"
		@keydown.space.prevent="onSelect"
	>
		<div class="menu-icon-option-item-icon-wrapper">
			<t-timpex-icon
				:icon="icon"
				:type="type"
				:color="selected ? 'blue' : 'neutral'"
				size="sm"
				class="menu-icon-option-item-icon"
			/>
		</div>
		<div :class="[{selected: selected, bold: bold}]" class="menu-icon-option-item-inner" @click="handleDeselect">
			<slot>{{getDisplayName}}</slot>
		</div>
		<div class="menu-icon-option-item-tick-wrapper">
			<t-timpex-icon
				v-show="selected"
				:class="[{selected: selected}]"
				icon="tick"
				type="bp"
				size="xs"
				class="menu-icon-option-item-tick"
			/>
		</div>
	</div>
</template>

<script>
import menuItemMixin from './menuItemMixin';
import menuOptionItemMixin from './menuOptionItemMixin';
import TTimpexIcon from '../timpex/icons/TTimpexIcon';
export default {
	name: 'TMenuIconOptionItem',
	components: { TTimpexIcon },
	mixins: [ menuItemMixin, menuOptionItemMixin ],
	props: {
		icon: String,
		type: String
	},
	computed: {
		getDisplayName() {
			return this.displayName || this.value;
		}
	},
	methods: {
		handleDeselect() {
			this.$emit('deselect', this.value);
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';
	.menu-icon-option-item {
		@extend %font-families-ui;
		@extend %text-default;
		user-select: none;
		color: get-color($text, 'muted');
		margin-top: 0;
		cursor: pointer;
		outline: none;
		display: flex;
		box-sizing: border-box;
		align-items: center;
		&.selected {
			background-color: rgba(16, 112, 202, 0.06);
		}
		&:hover {
			background-color: rgba(67, 90, 111, 0.04);
		}
		&:active {
			background-color: rgba(16, 112, 202, 0.06);
		}
		&:focus {
			background-color: rgba(16, 112, 202, 0.04);
		}
	}

	.menu-icon-option-item-icon-wrapper {
		display: flex;
		justify-content: center;
		padding-left: 8px;
		padding-right: 8px;
	}

	.menu-icon-option-item-icon {
		box-sizing: border-box;
	}
	.menu-icon-option-item-tick-wrapper {
		display: flex;
		justify-content: center;
		padding-left: 8px;
		padding-right: 12px;
	}

	.menu-icon-option-item-tick {
		color: get-color($icon, 'default');
		box-sizing: border-box;
		&.selected {
			color: get-color($blue, 'base');
		}
	}

	.menu-icon-option-item-inner {
		flex:1;
		min-height: 32px;
		font-weight: 400;
		font-size: 12px;
		padding: 5px 0;
		margin-left: 0;
		margin-right: 0;
		border-bottom: 1px solid rgb(237, 240, 242);
		box-sizing: border-box;
		&.selected {
			color: get-color($blue, 'base');
		}
		&.bold {
			font-weight: 500;
		}
	}
</style>
